import { Progress as ProgressDto } from "src/app/proxy/progresses/models";

export class Progress {
  id: number;
  projectId: number;
  roadId: number;
  userId: number;
  user: string;
  originId: string;
  date: string;
  isRejected: boolean;
  version: number;
  operation: string;
  roadClosed: boolean;
  pendingSend: boolean;

  constructor(dto: ProgressDto) {
    Object.assign(this, dto);
  }
}
